module.exports = __webpack_public_path__ + "img/icon_avoid_calling.2050c7ea.svg";